// src/auth.js
import { supabase } from './supabase';

let currentSession = null;

// Get session once on app load
export const initSession = async () => {
  const { data } = await supabase.auth.getSession();
  currentSession = data.session;
};

// Keep session in sync on login/logout
supabase.auth.onAuthStateChange((_event, session) => {
  currentSession = session;
});

export const getSession = () => currentSession;
